import {
  ScreenerSettingName,
  useIsScreenerSettingEnabled
} from '@/hooks/screener-settings';
import {
  ALL_FACILITIES,
  useSelectedFacilityId
} from '@/hooks/useFacilitiesQuery';
import { ExacareFeature, FeatureFlagService } from '@/utils/featureFlagService';

/**
 * Falls back to the currently selected facility (via `useSelectedFacilityId`)
 * to preserve the no-argument call signature; canonical readers themselves do
 * not fall back.
 */
export function useIsScreenerLeadWaitlistEnabled(): boolean {
  const selectedFacilityId = useSelectedFacilityId();
  const effectiveFacilityId =
    typeof selectedFacilityId === 'string' &&
    selectedFacilityId !== ALL_FACILITIES
      ? selectedFacilityId
      : '';

  const settingEnabled = useIsScreenerSettingEnabled(
    ScreenerSettingName.WaitlistEnabled,
    effectiveFacilityId
  );

  const featureFlagEnabled = FeatureFlagService.isEnabled(
    ExacareFeature.CRM_SCREENER_LEAD_WAITLIST
  );

  return featureFlagEnabled && settingEnabled;
}
